export default __webpack_public_path__ + "static/media/640_private03-es-mobile.c768fb55.png";